import { render } from "./CardBrandSelectorOption.vue?vue&type=template&id=f671beec&lang=pug"
import script from "./CardBrandSelectorOption.vue?vue&type=script&lang=js"
export * from "./CardBrandSelectorOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__